import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { useSnackbar } from '../../../helpers/hooks/useSnackbar'
import { selectActiveBuilding, selectBuildings } from '../../../reducers/buildingSelectorReducer'
import DigitalSignageAddNewLocationPopup from '../../Popups/DigitalSignageAddNewLocationPopup'
import ConfirmPopup from '../../Popups/ConfirmPopup'
import API from '../../../api/api'

import DigitalSignageHeader from './DigitalSignageHeader'
import DigitalSignageTable from './DigitalSignageTable'
import { useFetchLocations } from './hooks'
import { getActionsStatuses } from './constants'

const DigitalSignage = ({ selectedBuilding }) => {
  const { t } = useTranslation(['digital-signage', 'common'])
  const ACTIONS_STATUSES = getActionsStatuses(t)
  const { data: locations, refetch } = useFetchLocations({
    buildingId: selectedBuilding ? selectedBuilding.id : null,
  })

  const [addNewLocation, setAddNewLocation] = useState(false)
  const [deleteTvApp, setTvApp] = useState({ id: null, locationName: null })
  const { displaySnackbar } = useSnackbar()

  useEffect(() => {
    selectedBuilding && refetch(selectedBuilding.id)
  }, [selectedBuilding])

  const onDeleteLocation = async () => {
    if (!deleteTvApp.id) return
    try {
      await API.deleteDigitalSignageLocation(deleteTvApp.id)
      await refetch(selectedBuilding.id)
      displaySnackbar(ACTIONS_STATUSES.LOCATION_DELETED(deleteTvApp.locationName))
      setTvApp({ id: null, locationName: null })
    } catch {
      displaySnackbar(ACTIONS_STATUSES.LOCATION_DELETE_ERROR, true)
    }
  }

  const onAddNewLocation = async (buildingId, locationName) => {
    try {
      await API.createDigitalSignageLocation(buildingId, locationName)
      await refetch(buildingId)
      displaySnackbar(ACTIONS_STATUSES.LOCATION_ADDED(locationName))
    } catch {
      displaySnackbar(ACTIONS_STATUSES.LOCATION_ADDED_ERROR, true)
    }
  }

  return selectedBuilding ? (
    <div className="digital-signage-wrapper">
      <DigitalSignageHeader onAddLocation={() => setAddNewLocation(true)} />
      <main className="digital-signage-main">
        <DigitalSignageTable
          buildingId={selectedBuilding.id}
          locations={locations || []}
          setTvApp={setTvApp}
          refetchLocations={refetch}
        />
      </main>
      <ConfirmPopup
        title={t('digital-signage:confirmDelete.title')}
        body={t('digital-signage:confirmDelete.body', { locationName: deleteTvApp.locationName })}
        cancelText={t('common:actions.cancel')}
        confirmText={t('digital-signage:confirmDelete.confirmButton')}
        isOpen={Boolean(deleteTvApp.id)}
        cancelCallback={() => setTvApp({ id: null, locationName: null })}
        confirmCallback={onDeleteLocation}
      />
      <DigitalSignageAddNewLocationPopup
        buildingId={selectedBuilding.id}
        open={addNewLocation}
        onClose={() => setAddNewLocation(false)}
        onSubmit={onAddNewLocation}
      />
    </div>
  ) : null
}

DigitalSignage.propTypes = {
  buildings: PropTypes.array.isRequired,
  selectedBuilding: PropTypes.object,
}

const mapStateToProps = (state) => ({
  buildings: selectBuildings(state),
  selectedBuilding: selectActiveBuilding(state),
})

export default connect(mapStateToProps)(DigitalSignage)
